import React from 'react';
import camelCase from 'lodash/camelCase';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';

import { ValidationLayout } from '@thinknet-gmbh/platform-common-ui';
import { AccountFillStageEnum, PlatformModulesEnum } from '@thinknet-gmbh/platform-common';

import { useAuthAxiosInstance } from 'src/pages/auth/auth.axios.instance/';
import { ROUTES } from 'src/components/app/app-routes.constants';
import { useRouteQuery } from 'src/common/helpers';

const Validation: React.FC = () => {
  const navigate = useNavigate();
  const { validate, resendCode } = useAuthAxiosInstance();
  const { t } = useTranslation(['auth', 'common']);
  const query = useRouteQuery();
  const status: string = query.get('status') || '';
  const isVerificationStage = status !== AccountFillStageEnum.COMPLETED;

  return (
    <ValidationLayout
      t={t}
      isVerificationStage={isVerificationStage}
      camelCase={camelCase}
      module={PlatformModulesEnum.YUU_HR_MODULE}
      navigate={() => navigate(ROUTES.dashboard)}
      validate={validate}
      resendCode={resendCode}
    />
  );
};

export default Validation;
